import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export const useFormSchema = () => {
  const { t } = useTranslation();

  return z
    .object({
      beginn: z.string(),
      ende: z.string().optional(),
      kommen: z.string().optional(),
      gehen: z.string().optional(),
      planBeginn: z.string().optional(),
      planEnde: z.string().optional(),
    })
    .refine((data) => data.beginn !== '', {
      message: t(
        'domain.arbeitszeiten.sheet.arbeitszeit.arbeitszeitError.editOhneBeginn',
      ),
      path: ['dauer'],
    });
};
export type FormValues = z.infer<ReturnType<typeof useFormSchema>>;
